const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

class PriceTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'product': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.product = this.settings.product;
        if(!this.product.id){
            window.notify("Missing valid product","error");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.loadData();
    }

    refresh(){
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$container
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildProductQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildTab(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildProductQuery(){
        var self = this;

        let id = this.product.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',
            'reference',
            'price',
            'supplierPrice',
            'unit',
            'quantity',
            'status',
            'restaurantVisibilities { restaurant { id name } status }',
            'restaurantPriceUpdates { restaurant { id name } price }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProduct',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    onDOMReady(){
    }

    buildTab(data){
        this.product = data.supplierProduct;
        let generalPrice = window.formatFloat(this.product.price,2);
        let buyPrice = window.formatFloat(this.product.supplierPrice,2);
        let packaging = window.formatFloat(this.product.quantity,2) + ' ' + this.product.unit;
        let synthesisLabel = window.translate('app.product.show.tabs.prices.synthesis.title',{
            '%generalPrice%': generalPrice,
            '%buyPrice%': buyPrice,
            '%packaging%': packaging,
        });


        this.$container
        .html('')
        .append(
            $('<div/>')
            .addClass('white-box')
            .append(
                $('<h5>')
                .append(synthesisLabel)
            )
            .append(
                $('<small/>')
                .addClass('text-muted')
                .append(window.translate('app.product.show.tabs.prices.subtitle'))
            )
            .append(this.buildList())
        );

        this.onDOMReady();
    }


    buildList(){
        var self = this;
        this.$listContainer = $('<div/>')
        .addClass('mt-4');

        let $table = $("<table/>")
        .addClass('table table-striped')
        .append(
            $('<thead/>')
            .append(
                $('<tr/>')
                .append(
                    $('<th/>')
                    .append(window.translate('app.product.show.tabs.prices.restaurant.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.product.show.tabs.prices.visibility.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.product.show.tabs.prices.priceUpdate.label'))
                )
            )
        )


        let list = this.getSortedList();
        let $tbody = $('<tbody/>');

        $table
        .append($tbody);

        for(var i in list){
            let item = list[i];

            let restaurantId = item.restaurantId;
            let restaurant = item.name;
            let status = item.status;
            let price = item.priceUpdate;

            let $status = $('<select/>')
            .addClass('form-control')
            .attr('name','visibility['+restaurantId+']')
            .on('change',function(){
                self.onChangeStatus(restaurantId,$status);
            });

            for(var i=0;i<3;i++){
                let value = i;
                let label = window.translate('product.status.'+value);
                let selected = value == status ? true : false;

                let $option = $("<option/>")
                .val(value)
                .append(label);
                if(selected){
                    $option.attr('selected','selected')
                }

                $status.append($option);
            }

            let $price = $('<input/>')
            .attr('type','text')
            .addClass('form-control')
            .attr('name','priceUpdate['+restaurantId+']')
            .val(price)
            .on('change',function(){
                self.onChangePrice(restaurantId,$price);
            });


            let $line = $('<tr/>')
            .append(
                $('<td/>')
                .append(restaurant)
            )
            .append(
                $('<td/>')
                .append($status)
            )
            .append(
                $('<td/>')
                .append($price)
            )

            $tbody.append($line);
        }

        this.$listContainer
        .append($table);

        return this.$listContainer;
    }

    getSortedList(){
        let restaurants = {};

        for(var i in this.product.restaurantPriceUpdates){
            let priceUpdate = this.product.restaurantPriceUpdates[i];
            let restaurant = priceUpdate.restaurant;
            let price = priceUpdate.price;

            restaurants[restaurant.id] = {
                'restaurantId': restaurant.id,
                'name': restaurant.name,
                'priceUpdate': price,
                'status': this.product.status,
            };
        }

        for(var i in this.product.restaurantVisibilities){
            let visibility = this.product.restaurantVisibilities[i];
            let restaurant = visibility.restaurant;
            let status = visibility.status;

            if(restaurants[restaurant.id]){
                restaurants[restaurant.id].status = status;
            }else{
                restaurants[restaurant.id] = {
                    'restaurantId': restaurant.id,
                    'name': restaurant.name,
                    'priceUpdate': this.product.price,
                    'status': status,
                };
            }
        }

        let list = [];
        let ids = Object.keys(restaurants);
        for(var i in ids){
            let id = ids[i];
            list.push(restaurants[id]);
        }

        return list.sort(function(a,b){
            return a.name.localeCompare(b.name);
        });
    }
    onChangeStatus(restaurantId,$status){
        var self = this;
        let status = $status.val();
        $status.attr('disabled','disabled');

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant':{
                'value': restaurantId,
                'type': 'Int!'
            },
            'product': {
                'value': this.product.id,
                'type': 'Int!'
            },
            'status':{
                'value': status,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitRestaurantProductVisibility",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,'success');
                }else{
                    window.notify(data.message,'error');
                }
                self.refresh();
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
                $status.removeAttr('disabled');
            }
        });
        mutation.execute();
    }

    onChangePrice(restaurantId,$price){
        var self = this;

        let price = $price.val();
        price = price.replace(',','.');

        $price.attr('disabled','disabled');
        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant':{
                'value': restaurantId,
                'type': 'Int!'
            },
            'product': {
                'value': this.product.id,
                'type': 'Int!'
            },
            'price':{
                'value': price,
                'type': 'String!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitRestaurantProductPriceUpdate",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,'success');
                }else{
                    window.notify(data.message,'error');
                }
                self.refresh();
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
                $price.removeAttr('disabled');
            }
        });
        mutation.execute();
    }

}

module.exports = PriceTab;

